import {
  Button,
  Grid,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useRemoveBahasa } from "../../../../api/effects/mutations/Bahasa/removeBahasa";
import { RemoveModal } from "../../../../components/RemoveModal";
import { BahasaResponse } from "../../../../models/Bahasa";
import BahasaModal from "./BahasaModal";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "90%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

type Props = {
  data: BahasaResponse[];
};

export default function BahasaTable({ data }: Props) {
  const [editId, setEditId] = useState<number | null>(null);
  const [deletingId, setDeletingId] = useState<number | null>(null);
  const [removeModalText, setRemoveModalText] = useState("");

  const handleOpenRemoveModal = (text: string, id: number) => {
    setDeletingId(id);
    setRemoveModalText(`Remove ${text}?`);
  };

  const handleCloseRemoveModal = () => {
    setDeletingId(null);
  };

  const handleOpenEditModal = (id: number) => {
    setEditId(id);
  };

  const handleCloseEditModal = () => {
    setEditId(null);
  };

  const { mutateAsync: RemoveBahasa } = useRemoveBahasa({
    onSuccess() {
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  const handleRemove = () => {
    if (deletingId !== null) {
      RemoveBahasa(deletingId);
      handleCloseRemoveModal();
    }
  };

  return (
    <Grid container justifyContent="center">
      <BahasaModal
        open={!!editId}
        handleClose={handleCloseEditModal}
        ID={editId || undefined}
      />
      <RemoveModal
        open={!!deletingId}
        handleClose={handleCloseRemoveModal}
        handleRemove={handleRemove}
        text={removeModalText}
      />
      <SquareGrid container>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Action</TableCell>
                <TableCell>Bahasa </TableCell>
                <TableCell>Berbicara</TableCell>
                <TableCell>Mendengar</TableCell>
                <TableCell>Menulis</TableCell>
                <TableCell>Membaca</TableCell>
                <TableCell align="center">Hapus</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row) => (
                <TableRow
                  key={row.BAHASA_ID}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    <Button
                      onClick={() => handleOpenEditModal(row.BAHASA_ID)}
                      disabled={!!deletingId || !!editId}
                    >
                      Ubah
                    </Button>
                  </TableCell>
                  <TableCell>{row.BAHASA}</TableCell>
                  <TableCell>{row.BERBICARA}</TableCell>
                  <TableCell>{row.MENDENGAR}</TableCell>
                  <TableCell>{row.MENULIS}</TableCell>
                  <TableCell>{row.MEMBACA}</TableCell>
                  <TableCell align="center">
                    <Button
                      color="error"
                      onClick={() =>
                        handleOpenRemoveModal(`${row.BAHASA}`, row.BAHASA_ID)
                      }
                      disabled={!!deletingId || !!editId}
                    >
                      Hapus
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SquareGrid>
    </Grid>
  );
}